import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { ProblemItem } from '../api/financeTypes'
import { subscriptionPage, creditPage, userPage } from './links'

/** Actions NEVER write from the dashboard (v1 has no write route here): they
 * link to the existing write pages, which already write `admin_operations`
 * and ask for their own confirmation. Where no such page exists yet the
 * button is disabled with the tooltip "hamarosan" (follow-up ticket). */
export function SoonButton({ children, primary }: { children: string; primary?: boolean }) {
  return (
    <span title="hamarosan" className="af-soon">
      <button type="button" className={primary ? 'af-btn af-btn--primary' : 'af-btn'} disabled aria-disabled="true">
        {children}
      </button>
    </span>
  )
}


export function ProblemActions({ item }: { item: ProblemItem }) {
  const email = item.email
  const open = email ? (
    <Link className="af-btn" to={userPage(email)}>
      Megnyit
    </Link>
  ) : null
  let main: ReactNode
  switch (item.kind) {
    case 'unknown_outcome':
      main = <SoonButton primary>Egyeztetés</SoonButton>
      break
    case 'declined':
      main = <SoonButton primary>Újrapróbálás most</SoonButton>
      break
    case 'overdue':
      main = email ? (
        <Link className="af-btn af-btn--primary" to={subscriptionPage(item.project_id, email)}>
          Tartozás rendezése
        </Link>
      ) : null
      break
    case 'negative_credit':
      main = email ? (
        <Link className="af-btn af-btn--primary" to={creditPage(item.project_id, email)}>
          Kredit jóváírás
        </Link>
      ) : null
      break
    case 'month_close_missing':
      main = <SoonButton primary>Zárás indítása</SoonButton>
      break
    default:
      main = <SoonButton>Ügyfél értesítése</SoonButton>
  }
  return (
    <span className="af-actions">
      {main}
      {open}
    </span>
  )
}
